import { useEffect } from 'react';

import {
  requestFormStoreActions,
  useGetMerchants,
  useRequestForm,
} from '@entities/merchant';

import { useSearchParamsPagination } from '@shared/hooks';

const useMerchantsPage = () => {
  const { page, setPage } = useSearchParamsPagination();
  const { merchants, isLoading, isValidating, error } = useGetMerchants(page);
  const { methods } = useRequestForm(() => setPage(1));

  const formValues = methods.getValues();

  const handlePageClick = (event: { selected: number }) => {
    const newPage = event.selected + 1;

    requestFormStoreActions.updateOffset(newPage);
    setPage(newPage);
  };

  useEffect(() => {
    if (!isLoading && page > 1 && !merchants.items.length) {
      requestFormStoreActions.updateOffset(1);
      setPage(1);
    }
  }, [isLoading]);

  return {
    methods,
    merchants,
    isLoading: isLoading || isValidating,
    error,
    page,
    pageCount: Math.ceil(merchants.total / formValues.limit),
    handlePageClick,
  };
};

export default useMerchantsPage;
